/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import IconMonitoramento from '../../imgs/marker-map.svg';
import IconCadastros from '../../imgs/ocorrencia-1.svg';
import IconOcorrencia from '../../imgs/ocorrence.svg';
import IconHistorico from '../../imgs/Car_Historico.svg';
import IconCerca from '../../imgs/cerca-eletronica.svg';
import IconComposicao from '../../imgs/composição.svg';
import IconGraficos from '../../imgs/Grafico_black.svg';
import IconRelatorio from '../../imgs/relatorio.svg';

import './styles.css';
import { useAuthData } from 'hooks/auth/useAuthData';

function Home() {
  const history = useHistory();
  const { data } = useAuthData();
  const { roles } = data || {};

  const isPermitted = useCallback(
    (role: string) => {
      return (roles || []).filter((item: string) => item === role).length > 0;
    },
    [roles]
  );

  const pages = [
    {
      title: 'Monitoramento',
      subtitle: 'Monitoramento em tempo real de viaturas',
      classname: 'card-icon card-icon-red',
      role: 'ROLE_ROTAS_MONITORAMENTO',
      path: '/mapa/monitoramento',
      src: IconMonitoramento,
    },
    {
      title: 'Histórico',
      subtitle: 'Histórico de posições',
      classname: 'card-icon card-icon-green',
      role: 'ROLE_ROTAS_HISTORICO',
      path: '/mapa/historico',
      src: IconHistorico,
    },
    {
      title: 'Cadastros',
      subtitle: 'Menu de Cadastros',
      classname: 'card-icon card-icon-orange',
      role: 'ROLE_ROTAS_CADASTROS',
      path: '/cadastros',
      src: IconCadastros,
    },
    {
      title: 'Ocorrências',
      subtitle: 'Monitoramento de ocorrências',
      classname: 'card-icon card-icon-yello',
      role: 'ROLE_ROTAS_OCORRENCIA',
      path: '/ocorrencias',
      src: IconOcorrencia,
    },
    {
      title: 'Cercas',
      subtitle: 'Gerenciamento de Cercas Eletrônicas',
      classname: 'card-icon card-icon-blue',
      role: 'ROLE_ROTAS_VISUALIZACAO_CERCA',
      path: '/cerca',
      src: IconCerca,
    },
    {
      title: 'Composição',
      subtitle: 'Historico de composição das viaturas',
      classname: 'card-icon card-icon-purple',
      role: 'ROLE_ROTAS_HISTORICO_CONEXAO',
      path: '/composicao',
      src: IconComposicao,
    },
    {
      title: 'Estatísticas',
      subtitle: 'Upload de arquivos estatísticos SUPESP',
      classname: 'card-icon card-icon-teal',
      role: 'ROLE_ROTAS_UPLOAD_ARQUIVOS_SUPESP',
      path: '/estatisticas-supesp',
      src: IconComposicao,
    },
    {
      title: 'Relatórios',
      subtitle: 'Relatórios disponíveis',
      classname: 'card-icon card-icon-grey',
      role: 'ROLE_ROTAS_RELATORIOS',
      path: '/relatorios',
      src: IconRelatorio,
    },
    {
      title: 'Gráficos',
      subtitle: 'gráficos comparativos de ocupação de viaturas',
      classname: 'card-icon card-icon-navy',
      role: 'ROLE_ROTAS_GRAFICOS',
      path: '/graficos',
      src: IconGraficos,
    },
  ];

  return (
    <div className="container">
      <div className="row">
        {pages
          .filter(page => isPermitted(page.role))
          .map(page => (
            <div className="card-01" onClick={() => history.push(page.path)}>
              <div className="titleContainer">
                <div className="title-card">{page.title}</div>
                <div className="subtitle-card">{page.subtitle}</div>
              </div>
              <div className={page.classname}>
                <div className="img-icon">
                  <img
                    src={page.src}
                    alt={page.title}
                    className="iconComponent"
                  />
                  {/* <IconMonitoramento className="iconComponent" /> */}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Home;
